module.exports = __webpack_public_path__ + "1611db152d01e0023ee919c022583f88.png";